export class PasswordModel {
    constructor(OldPassword, NewPassword) {
        this.OldPassword = OldPassword;
        this.NewPassword = NewPassword;
    }
}